export default __webpack_public_path__ + "static/side-nav-dont-2-af40102a0f1c0321673d26875c6a43a10b34de79a0a9384c75f1c03bb29d1e1f.png";